import Axios from "axios";
import ApiUtils from "../utils/api_utils";
import { PaginationDM } from "../data_model/pagination_dm";
import { DashboardDM } from "../data_model/dashboard_dm";
import { RewardVoucherDM } from "../data_model/reward_voucher_dm";
import { MyVoucherDM } from "../data_model/myvoucher_dm";
import { CityDM } from "../data_model/city_dm";

const RewardSM = {
  state: {
    reward_dashboard: new DashboardDM({}),
    reward_vouchers_detail: new RewardVoucherDM({}),
    reward_myvouchers_detail: new MyVoucherDM({}),
    myvoucher: new PaginationDM({}),
    categories: [],
    categoriesDiscount: [],
    listCity: new CityDM({}),
    reward_nearby: new PaginationDM({}),
    voucherData: [],
    dataBank: [],
  },
  reducers: {
    setRewardState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    /**
     * get reward by location nearby
     * payload { lat, lng, category, sub_category }
     */
    async getRewardByLocationNearby(payload, rootState) {
      let result;
      await Axios.get(
        `https://${ApiUtils.authority}/rewards/api/locations/nearby/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
          params: payload,
        }
      )
        .then(function (response) {
          const data = PaginationDM.fromJson(response.data);

          dispatch.RewardSM.setRewardState({
            ...rootState.RewardSM,
            reward_nearby: data,
          });
          result = {
            status: 200,
            message: "success",
            data: data,
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
            data: new PaginationDM({}),
          };
        });

      return result;
    },

    /**
     * get reward by category => { category, sub_category } OR
     * get reward by city => { city, category, sub_category }
     */
    async getReward(payload, rootState) {
      await Axios.get(`https://${ApiUtils.authority}/rewards/api/rewards/`, {
        params: payload,
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function () {})
        .catch(function () {});
    },

    /**
     * get reward by city
     */
    async getRewardDetails({ id }, rootState) {
      let result;
      await Axios.get(
        `https://${ApiUtils.authority}/rewards/api/rewards/${id}/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          const data = RewardVoucherDM.fromJson(response.data);
          dispatch.RewardSM.setRewardState({
            ...rootState.RewardSM,
            reward_vouchers_detail: data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    /**
     * get cities
     */
    async getCities(payload, rootState) {
      await Axios.get(`https://${ApiUtils.authority}/rewards/api/cities/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function () {})
        .catch(function () {});
    },
    /**
     * get Categories
     */
    async getCategories({ type }, rootState) {
      await Axios.get(`https://${ApiUtils.authority}/rewards/api/categories`, {
        params: {
          type,
        },
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function () {})
        .catch(function () {});
    },
    /**
     * get Voucher by Categories
     */
    async getVoucherPoints(params, rootState) {
      let result;
      await Axios.get(`https://${ApiUtils.authority}/rewards/api/rewards/`, {
        params: params,
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          const data = PaginationDM.fromJson(response.data);
          dispatch.RewardSM.setRewardState({
            ...rootState.RewardSM,
            voucherData: data,
          });
          result = {
            status: 200,
            message: "success",
            data: data,
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
            data: new PaginationDM({}),
          };
        });

      return result;
    },
    /**
     * get unused voucher / my vouchers
     */
    async getUnusedVoucher(param = {}, rootState) {
      let result;
      await Axios.get(`https://${ApiUtils.authority}/wallet/api/wallet/`, {
        params: {
          ...param,
        },
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          const data = PaginationDM.fromJson(response.data);
          dispatch.RewardSM.setRewardState({
            ...rootState.RewardSM,
            myvoucher: data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    /**
     * get reward by city
     */
    async getVoucherDetails({ id }, rootState) {
      let result;
      await Axios.get(
        `https://${ApiUtils.authority}/wallet/api/wallet/${id}/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          const data = MyVoucherDM.fromJson(response.data);
          dispatch.RewardSM.setRewardState({
            ...rootState.RewardSM,
            reward_myvouchers_detail: data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    /**
     * get rewards dashboard
     */
    async getRewardDasboard(payload, rootState) {
      let result;
      await Axios.get(
        `https://${ApiUtils.authority}/rewards/api/rewards/dashboard/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          const data = DashboardDM.fromJson(response.data);
          dispatch.RewardSM.setRewardState({
            ...rootState.RewardSM,
            reward_dashboard: data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    /**
     * get all banks
     */
    async getAllBanks(_payload, rootState) {
      await Axios.get(`https://${ApiUtils.authority}/rewards/api/banks/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          dispatch.RewardSM.setRewardState({
            ...rootState.RewardSM,
            dataBank: response.data.data,
          });
        })
        .catch(function () {});
    },

    async initRewardPage(payload, rootState) {
      let endpoints = [
        `https://${ApiUtils.authority}/rewards/api/rewards/dashboard/`,
        `https://${ApiUtils.authority}/rewards/api/categories/?type=point`,
        `https://${ApiUtils.authority}/rewards/api/categories/?type=discount`,
        `https://${ApiUtils.authority}/rewards/api/cities/`,
      ];

      Promise.all(
        endpoints.map((endpoint) =>
          Axios.get(endpoint, {
            headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
            withCredentials: false,
          })
        )
      ).then(
        ([
          { data: reward_dashboard },
          { data: categories },
          { data: categoriesDiscount },
          { data: listCity },
        ]) => {
          dispatch.RewardSM.setRewardState({
            ...rootState.RewardSM,
            reward_dashboard: DashboardDM.fromJson(reward_dashboard),
            categories: categories,
            categoriesDiscount: categoriesDiscount,
            listCity: listCity,
          });
        }
      );
    },
  }),
};

export default RewardSM;
